export default __webpack_public_path__ + "static/media/apple-logo-desktop.91d1729c.svg";